import tensureLogo from '../../assets/images/Tensure_logo.jpg';

const LogoFull = () => {
  return (
    <img src={tensureLogo} alt="Tensure Logo" style={{ height: 30, width: 'auto' }} />
  );
};

export default LogoFull;
